import {useAtom} from 'jotai';
import persistentAtom from 'shared/atoms/persistent-atom';

const tokenAtom = persistentAtom<string | null>('token', null);

const useToken = () => {
  const [token, setToken] = useAtom(tokenAtom);
  return {token, setToken};
};

export default useToken;
